export enum LogSorterColumnPlacement {
  Left,
  Right,
}
